import { observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';

import { PasswordFormState, RouteParams } from '../../shared/password-form-state';
import { LoginStore } from '../../stores/login.store';
import { lazyInject } from '../../ioc';
import { LoginApiService } from 'src/api';

import { SignUpPassword } from './desktop/sign-up-password';
import { RouteComponentProps } from 'react-router';

interface Props extends RouteComponentProps<RouteParams> {
    step: 1 | 2;
}

@observer
export class SignUpPasswordContainer extends React.Component<Props> {
    @lazyInject(LoginApiService) private loginApi!: LoginApiService;
    @lazyInject(LoginStore) private loginStore!: LoginStore;

    @observable data!: PasswordFormState;
    private resolvePromise: ((token: string) => void) | undefined;

    constructor(props: Props) {
        super(props);
        this.resetForm(props);
    }

    componentWillReceiveProps(nextProps: Readonly<Props>) {
        if (this.props.step !== nextProps.step) {
            this.resetForm(nextProps);
        }
    }

    componentDidMount() {
        renderReCaptcha(this.reCaptchaCallback);
    }

    private resetForm(props: Readonly<Props>) {
        this.data = new PasswordFormState(props.step, props.match.params.token, this.onSubmit, '/');
    }

    private onSubmit = async (token: string, email: string, password: string) => {
        try {
            const result = await this.loginApi.create({ token, email, password });
            if (!result.data.success) {
                return Promise.reject('Cannot set up password');
            }

            const reCaptchaToken = await this.getReCaptchaPromise();
            return this.loginStore
                .authenticate({
                    email,
                    password,
                    reCaptchaToken,
                    stayLoggedIn: false,
                })
                .then(() => true);
        } catch (e) {
            return Promise.reject(e);
        }
    };

    private getReCaptchaPromise(): Promise<string> {
        const promise = new Promise<string>((resolve) => (this.resolvePromise = resolve));
        grecaptcha.execute();
        return promise;
    }

    private reCaptchaCallback = (reCaptchaToken: string) => {
        if (this.resolvePromise) {
            this.resolvePromise(reCaptchaToken);
            this.resolvePromise = undefined;
        }
    };

    render() {
        return <SignUpPassword container={this} />;
    }
}
